module.exports = __webpack_public_path__ + "img/forbes.5efee78e.png";